import { render, staticRenderFns } from "./cimage.vue?vue&type=template&id=3be02386&scoped=true&"
import script from "./cimage.vue?vue&type=script&lang=js&"
export * from "./cimage.vue?vue&type=script&lang=js&"
import style0 from "./cimage.vue?vue&type=style&index=0&id=3be02386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be02386",
  null
  
)

export default component.exports